import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/App';

// Logo URLs
const SYMBOL_LOGO = "https://customer-assets.emergentagent.com/job_neuro-care-hub-2/artifacts/zntnld86_Lifely%20Symbol%20AI.png";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { googleLogin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processOAuthCallback = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        const result = await googleLogin(sessionId);
        
        if (result.success) {
          // Clear the hash and redirect based on role
          window.history.replaceState(null, '', window.location.pathname);
          const user = result.user;
          if (user.role === 'admin' || ['counselor', 'health_coach', 'doctor'].includes(user.role)) {
            navigate('/admin', { replace: true });
          } else {
            navigate('/dashboard', { replace: true });
          }
        } else {
          // Auth failed, redirect to login
          navigate('/login', { replace: true, state: { error: result.error } });
        }
      } else {
        // No session_id, redirect to login
        navigate('/login', { replace: true });
      }
    };

    processOAuthCallback();
  }, [googleLogin, navigate]);

  return (
    <div className="min-h-screen bg-[#080C14] flex items-center justify-center">
      <div className="text-center">
        <img src={SYMBOL_LOGO} alt="Lifely" className="w-16 h-16 mx-auto mb-6 animate-pulse" />
        <p className="text-white/60">Completing authentication...</p>
      </div>
    </div>
  );
}
